import blog from '../img/blog.png';

const blogs = [
    {
        id:1,
        title:"How to improve SEO",
        date:'01',
        month:'April',
        image: blog,
        link:'https://www.google.com/'
    },
    {
        id:2,
        title:"How to improve SEO",
        date:'01',
        month:'April',
        image: blog,
        link:'https://www.google.com/'
    },
    {
        id:3,
        title:"How to improve SEO",
        date:'01',
        month:'April',
        image: blog,
        link:'https://www.google.com/'
    },
    {
        id:4,
        title:"How to improve SEO",
        date:'01',
        month:'April',
        image: blog,
        link:'https://www.google.com/'
    }
]
export default blogs;  